import React from 'react';
import { motion } from 'framer-motion';
import { Gauge } from 'lucide-react';

const SpeedTestSection = () => {
  return (
    <section id="speedtest" className="relative py-24 overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900">
        {/* Animated Circles */}
        <div className="absolute inset-0 overflow-hidden">
          <motion.div
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full border border-white/10"
            animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.1, 0.3] }}
            transition={{ duration: 4, repeat: Infinity }}
          />
          <motion.div
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full border border-white/5"
            animate={{ scale: [1.2, 1, 1.2], opacity: [0.1, 0.3, 0.1] }}
            transition={{ duration: 4, repeat: Infinity }}
          />
          <motion.div
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] rounded-full border border-white/5"
            animate={{ scale: [1, 1.1, 1], opacity: [0.2, 0.05, 0.2] }}
            transition={{ duration: 5, repeat: Infinity }}
          />
        </div>
        
        {/* Gradient Orbs */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-500/20 rounded-full blur-[128px]" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-400/20 rounded-full blur-[128px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <motion.span
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white text-sm font-medium mb-6"
          >
            <Gauge className="w-4 h-4" />
            Teste de Velocidade
          </motion.span>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            Teste sua Conexão
          </h2>
          
          <p className="text-lg text-blue-100 max-w-2xl mx-auto">
            Verifique a velocidade da sua internet atual em tempo real.
          </p>
        </motion.div>

        {/* Speed Test Iframe Container */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto"
        >
          <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-4 md:p-6 border border-white/20 shadow-2xl overflow-hidden">
            <iframe 
              width="100%" 
              height="650px" 
              frameBorder="0" 
              src="https://gfa.speedtestcustom.com"
              title="Teste de Velocidade GFA Telecom"
              className="rounded-2xl"
            />
          </div>
          
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-center text-blue-200 text-sm mt-6"
          >
            Quer uma internet mais rápida?{' '}
            <a href="#planos" className="text-cyan-400 hover:underline font-medium">
              Conheça nossos planos
            </a>
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default SpeedTestSection;
